import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { IItem } from '@rbi-ctg/menu';
import { useUIContext } from 'state/ui';

import { PricePerContainer, PricePerLine } from './price-per-unit.styled';

export interface IPricePerUnitProps {
  product: IItem;
  totalAmount: number;
  formattedPrice: string;
}

export const PricePerUnit: FC<IPricePerUnitProps> = ({ product, totalAmount, formattedPrice }) => {
  const { formatCurrencyForLocale } = useUIContext();
  const { formatMessage } = useIntl();

  if (!product?.itemSize) {
    return null;
  }

  return (
    <PricePerContainer>
      <PricePerLine data-testid="price-per-filling">
        {formatMessage(
          { id: 'pricePerFilling' },
          {
            price: formattedPrice,
            filling: `${product.itemSize} ${product.itemUnit}`,
          }
        )}
      </PricePerLine>
      <PricePerLine data-testid="price-per-unit">
        {formatMessage(
          { id: 'pricePerUnit' },
          {
            price: formatCurrencyForLocale((1 / product.itemSize) * totalAmount),
            unit: product.itemUnit,
          }
        )}
      </PricePerLine>
    </PricePerContainer>
  );
};

export default PricePerUnit;
